app.controller("PhotoGalleryController",
	["$scope", "$rootScope", "$timeout", function($scope, $rootScope, $timeout) {
		$scope.show_ground_plan = false;
		$scope.fullscreen = false;
		$scope.breakpoints = [
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 7
				}
			},
			{
				breakpoint: 860,
				settings: {
					slidesToShow: 5
				}
			},
			{
				breakpoint: 620,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 380,
				settings: {
					slidesToShow: 1
				}
			}
		];

		$scope.ToggleFullscreen = function() {
			$scope.fullscreen = !$scope.fullscreen;
			$rootScope.fullscreen = $scope.fullscreen;
			var sliders = angular.element(document.querySelectorAll('.b-photo-gallery__slider'));
			if(sliders.length > 0) {
				$timeout(function() {
					for(var i = 0; i < sliders.length; i++) {
						$(sliders[i]).slick('setPosition');
					}
				}, 100);
			}
		};

		$scope.ToggleGroundPlan = function() {
			$scope.show_ground_plan = !$scope.show_ground_plan;
			var sliders = angular.element(document.querySelectorAll('.b-photo-gallery__slider'));
			if(sliders.length > 0) {
				$timeout(function() {
					for(var i = 0; i < sliders.length; i++) {
						$(sliders[i]).slick('slickGoTo', $(sliders[i]).slick('slickCurrentSlide'));
					}
				});
			}
		};

		angular.element('.b-photo-gallery__slider').on('afterChange', highlightThumbnail);
		angular.element('.b-photo-gallery__slider').on('init', function() {
			$timeout(function(event, slick) {
				var highlightIndex = (angular.element('.b-photo-gallery__slider').find('.b-photo-gallery__video-content').length || angular.element('.b-photo-gallery__slider').find('.b-photo-gallery__virtual-content').length) ? 0 : 1;
				var sliders = angular.element(document.querySelectorAll('.b-photo-gallery__slider'));

				if (sliders.length > 0) {
					$timeout(function() {
						for (var i = 0, max = sliders.length; i < max; i++) {
							$(sliders[i]).slick('slickGoTo', highlightIndex);
						}
					});
				}
				
				highlightThumbnail(event, slick, highlightIndex);
			}, 100);
		});

		function highlightThumbnail(event, slick, currentSlide) {
			var items = angular.element('.b-photo-gallery__nav');
			var activeItem = items.find('[data-slick-index=' + currentSlide + ']');

			items.find('[data-slick-index]').removeClass('b-photo-gallery__nav-image-active');
			activeItem.addClass('b-photo-gallery__nav-image-active');
		}
	}]
);